import moment from "moment";

export function toDOBFormat(birthDateString) {
  return moment(birthDateString).format("DD-MMM-YYYY");
}
